module.exports = __webpack_public_path__ + "static/img/fiber2.6d34fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fiber2.jpg
// module id = l+q9
// module chunks = 1